import React from 'react';
import { Route } from 'react-router-dom';
import NewDealWizard from '@features/deals/components/NewDealWizard';
import DealList from '@features/deals/components/DealList';
import DealDetails from '@features/deals/components/DealDetails';
import MainLayout from '@components/layout/MainLayout';

export const dealRoutes = [
  <Route
    key="deals"
    path="/deals"
    element={
      <MainLayout>
        <DealList />
      </MainLayout>
    }
  />,
  <Route
    key="deal-details"
    path="/deals/:dealId"
    element={
      <MainLayout>
        <DealDetails />
      </MainLayout>
    }
  />,
  <Route
    key="new-deal"
    path="/new-deal"
    element={
      <MainLayout>
        <NewDealWizard />
      </MainLayout>
    }
  />,
  <Route
    key="view-deals"
    path="/view-deals"
    element={
      <MainLayout>
        <DealList />
      </MainLayout>
    }
  />
];

export default dealRoutes;